import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import apiManager from '../../api/api-manager';
import { commonErrorMessages } from '../../messages';
import { GlobalActions } from '../../model';
import { appRoutes } from '../../routing';
import { ACTION_LOGOUT, getConfig } from '../../store';
import { useAppDispatch } from '../redux';

export const MAINTENANCE_ERROR_CODE = 'MAINTENANCE';

export const useApiResponseInterceptorLogic = (
  globalActions: GlobalActions
) => {
  const { showToast, closeToast, navigate } = globalActions;
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();

  useEffect(() => {
    const resInterceptor = (response) => response;

    const errInterceptor = (error) => {
      // While in maintenance the backend answers 401 MAINTENANCE to every call. Checked before the plain 401:
      // no logout and no expired-session toast, only read the config again, so that useConfigLogic moves to
      // the maintenance page even if the app was opened before the maintenance started
      if (
        error?.response?.data?.codiciErrore?.includes(MAINTENANCE_ERROR_CODE)
      ) {
        dispatch(getConfig());
        return Promise.reject(error);
      }

      if (error?.response?.status === 401) {
        navigate(appRoutes.Login, { replace: true });
        dispatch({
          type: ACTION_LOGOUT,
        });
        showToast({
          type: 'error',
          title: formatMessage(commonErrorMessages.errorExpiredToken),
          close: closeToast,
        });
        return Promise.reject(error);
      }

      return Promise.reject(error);
    };

    const interceptor = apiManager.axiosInstance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    return () =>
      apiManager.axiosInstance.interceptors.response.eject(interceptor);
  }, [showToast, closeToast, navigate, dispatch, formatMessage]);
};
